import React, { useContext, useEffect, useState } from "react";
import { Button, CardHeader, Form, Modal } from "react-bootstrap";
import ApplicationContext from "../../context/ApplicationContext";
import loadingImage from "../../images/loading.gif";
import {
  Accordion,
  AccordionContent,
  AccordionTitle,
  Card,
  CardContent,
  CardDescription,
  CardMeta,
  Grid,
  GridColumn,
  GridRow,
  Icon,
  Table,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "semantic-ui-react";
import { defaultReceiptData } from "../../types/IReceiptData";
import { defaultReceipt, IReceipt } from "../../types/IReceipt";
import { getReceipts } from "../../services/Service";
import { IReceiptRow } from "../../types/IReceiptRow";
import { useNavigate } from "react-router";
import { IEOD, IEODBreakdown } from "../../types/IEOD";

export interface IEndOfDayProps {
  close(): void;
  show: boolean;
}

export const EndOfDayModal: React.FC<IEndOfDayProps> = (
  props: IEndOfDayProps
): JSX.Element => {
  const context = useContext(ApplicationContext);
  const navigate = useNavigate();

  var today = new Date();

  const [receipts, setReceipts] = useState<IReceipt[]>([]);
  const [loading, setLoading] = useState(false);
  const [calculating, setCalculating] = useState(false);
  const [startDate, setStartDate] = useState(
    new Date(today.getFullYear(), today.getMonth(), today.getDate(), 1)
  );
  const [endDate, setEndDate] = useState(
    new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 1)
  );

  const [showFilter, setShowFilter] = useState(false);

  async function getReceiptData() {
    setLoading(true);

    const response = await getReceipts(
      startDate,
      endDate,
      context.AuthenticatedUser.getToken()
    );

    if (!response) {
      context.ApplicationError.setHasError(true);
      return;
    }

    setReceipts(response);
    setLoading(false);
  }

  function callHistory() {
    navigate("/Calls");
  }

  useEffect(() => {
    getReceiptData();
  }, []);

  function getTotal() {
    let total = 0;
    for (let idx = 0; idx < receipts.length; idx++) {
      const element = receipts[idx];
      total = total + element.total;
    }

    return total;
  }

  function paidByCard() {
    let card = 0;
    for (let idx = 0; idx < receipts.length; idx++) {
      const element = receipts[idx];
      if (element.paymentType === "Delivery") {
        card = card + 1;
      }
    }
    return card;
  }

  function totalCardPayment() {
    let cardTotal = 0;
    for (let idx = 0; idx < receipts.length; idx++) {
      const element = receipts[idx];
      if (element.paymentType === "Card") {
        cardTotal = cardTotal + element.total;
      }
    }
    return cardTotal;
  }

  function totalCashPayment() {
    let cashTotal = 0;
    for (let idx = 0; idx < receipts.length; idx++) {
      const element = receipts[idx];
      if (element.paymentType === "Cash") {
        cashTotal = cashTotal + element.total;
      }
    }
    return cashTotal;
  }

  function eatInCount() {
    let total = 0;
    for (let idx = 0; idx < receipts.length; idx++) {
      const element = receipts[idx];
      if (element.transactionType === "Eat in") {
        total = total + 1;
      }
    }
    return total;
  }

  function collectionCount() {
    let total = 0;
    for (let idx = 0; idx < receipts.length; idx++) {
      const element = receipts[idx];
      if (element.transactionType === "Collection") {
        total = total + 1;
      }
    }
    return total;
  }

  function takeoutCount() {
    let total = 0;
    for (let idx = 0; idx < receipts.length; idx++) {
      const element = receipts[idx];
      if (element.transactionType === "Takeout") {
        total = total + 1;
      }
    }
    return total;
  }

  function deliveryCount() {
    let total = 0;
    for (let idx = 0; idx < receipts.length; idx++) {
      const element = receipts[idx];
      if (element.transactionType === "Delivery") {
        total = total + 1;
      }
    }
    return total;
  }

  function formatDate(d: Date) {
    var date = d.toISOString().substring(0, 10);
    return date;
  }

  function formatTime(d: Date) {
    return d.toLocaleString("ru-RU", {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  function onStartChangeDate(value: string) {
    let dt = new Date(value);

    dt.setHours(startDate.getHours());
    dt.setMinutes(startDate.getMinutes());

    setStartDate(dt);
  }

  function onStartChangeTime(value: string) {
    const timeParts = value.split(":");

    let dt = new Date(startDate);
    dt.setHours(Number(timeParts[0]));
    dt.setMinutes(Number(timeParts[1]));

    setStartDate(dt);
  }

  function onEndChangeDate(value: string) {
    let dt = new Date(value);

    dt.setHours(endDate.getHours());
    dt.setMinutes(endDate.getMinutes());

    setEndDate(dt);
  }

  function onEndChangeTime(value: string) {
    const timeParts = value.split(":");

    let dt = new Date(endDate);
    dt.setHours(Number(timeParts[0]));
    dt.setMinutes(Number(timeParts[1]));

    setEndDate(dt);
  }

  function applyFilter() {
    getReceiptData();
  }

  const content = (): JSX.Element => (
    <>
      <div className="container-fluid">
        <Accordion fluid styled>
          <AccordionTitle
            active={showFilter}
            onClick={() => setShowFilter(!showFilter)}
          >
            <div style={{ float: "left" }}>Filter</div>
            <div style={{ textAlign: "right" }}>
              <Icon name="align justify" />
            </div>
          </AccordionTitle>
          <AccordionContent active={showFilter}>
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Report range</h5>
                <br />
                <p className="card-text">
                  Start date time
                  <br />
                  <input
                    type="date"
                    style={{ fontSize: 16 }}
                    value={formatDate(startDate)}
                    onChange={(e) => onStartChangeDate(e.target.value)}
                  ></input>
                  <input
                    type="time"
                    id="appt"
                    style={{ fontSize: 16 }}
                    value={formatTime(startDate)}
                    onChange={(e) => onStartChangeTime(e.target.value)}
                    name="appt"
                  ></input>
                  <br />
                  <br />
                  End date time <br />
                  <input
                    type="date"
                    style={{ fontSize: 16 }}
                    value={formatDate(endDate)}
                    onChange={(e) => onEndChangeDate(e.target.value)}
                  ></input>
                  <input
                    type="time"
                    style={{ fontSize: 16 }}
                    value={formatTime(endDate)}
                    onChange={(e) => onEndChangeTime(e.target.value)}
                  ></input>
                </p>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={applyFilter}
                >
                  Apply
                </button>
              </div>
            </div>
          </AccordionContent>
        </Accordion>
        <hr />

        <Grid columns="equal">
          <GridRow centered columns={3}>
            <GridColumn>
              <Card>
                <CardContent>
                  <CardHeader>
                    <h2 style={{ color: "green" }}>
                      {loading ? (
                        <img
                          src={loadingImage}
                          alt="Loading"
                          width={200}
                          height={60}
                        />
                      ) : (
                        "£" + getTotal().toFixed(2)
                      )}
                    </h2>
                  </CardHeader>
                  <CardMeta> </CardMeta>
                  <CardDescription>
                    <div style={{ height: 100 }}>
                      <p className="mb-0">
                        Card: £{totalCardPayment().toFixed(2)}
                      </p>
                      <p className="mb-0">
                        Cash: £{totalCashPayment().toFixed(2)}
                      </p>
                    </div>
                  </CardDescription>
                </CardContent>
              </Card>
            </GridColumn>
            <GridColumn>
              <Card>
                <CardContent>
                  <CardHeader>
                    <h2 style={{ color: "green" }}>
                      {loading ? (
                        <img
                          src={loadingImage}
                          alt="Loading"
                          width={200}
                          height={40}
                        />
                      ) : (
                        receipts.length + " Orders"
                      )}
                    </h2>
                  </CardHeader>
                  <CardMeta> </CardMeta>
                  <CardDescription>
                    <div style={{ height: 100 }}>
                      <p>Eat in: {eatInCount()}</p>
                      <p>Takeout: {takeoutCount()}</p>
                      <p>Collection: {collectionCount()}</p>
                      <p>Delivery: {deliveryCount()}</p>
                    </div>
                  </CardDescription>
                </CardContent>
              </Card>
            </GridColumn>
            {/* <GridColumn>
              <Card>
                <CardContent>
                  <CardHeader>
                    <h2 style={{ color: "green" }}>
                      {loading ? (
                        <img
                          src={loadingImage}
                          alt="Loading"
                          width={200}
                          height={40}
                        />
                      ) : (
                        // totalCalls() + " Calls"
                      )}
                    </h2>
                  </CardHeader>
                  <CardMeta></CardMeta>
                  <CardDescription>
                    <div style={{ height: 100 }}>
                      <div onClick={() => callHistory()}>
                        <a>history</a>
                      </div>
                    </div>
                  </CardDescription>
                </CardContent>
              </Card>
            </GridColumn> */}
            {/* <GridColumn>
              <Card>
                <CardContent>
                  <CardHeader>
                    <h2 style={{ color: "green" }}>
                      {loading ? (
                        <img
                          src={loadingImage}
                          alt="Loading"
                          width={200}
                          height={40}
                        />
                      ) : (
                        receipts.length + " App Orders"
                      )}
                    </h2>
                  </CardHeader>
                  <CardMeta></CardMeta>
                  <CardDescription>
                    <div style={{ height: 100 }}>
                      <div onClick={() => callHistory()}>no records found</div>
                    </div>
                  </CardDescription>
                </CardContent>
              </Card>
            </GridColumn> */}
          </GridRow>
        </Grid>
      </div>
    </>
  );

  function formatDateForDisplay(d: Date) {
    return (
      d.getDate() +
      "/" +
      d.getMonth() +
      "/" +
      d.getFullYear() +
      " - " +
      d.getHours() +
      ":" +
      d.getMinutes()
    );
  }

  function generateHash() {
    let x = Math.floor(Math.random() * 999999999 + 1);
    return x.toString();
  }

  const receiptRow = (r: IReceipt) => (
    <>
      <tr>
        <td>{generateHash()}</td>
        <td>{formatDateForDisplay(new Date(r.createdAt))}</td>
        <td>{r.total.toFixed(2)}</td>
        <td>
          <Button variant="link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-copy"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
              />
            </svg>
          </Button>
        </td>
        <td></td>
      </tr>
    </>
  );

  function EODBreakdownHelper(receipts: IReceipt[]) {
    let breakdown: IEODBreakdown[] = [];
    for (let i = 0; i < receipts.length; i++) {
      const receipt = receipts[i];
      for (let j = 0; j < receipt.rows.length; j++) {
        const receiptRow = receipt.rows[j];
        let foundIdx = undefined;
        for (let k = 0; k < breakdown.length; k++) {
          if (receiptRow.product.description === breakdown[k].name) {
            foundIdx = k;
            break;
          }
        }
        if (foundIdx === undefined) {
          const bd: IEODBreakdown = {
            name: receiptRow.product.description,
            count: 1,
          };
          breakdown.push(bd);
        } else {
          breakdown[foundIdx].count++;
        }
      }
    }
    return breakdown;
  }

  function printEOD() {
    const ebd = EODBreakdownHelper(receipts);

    setCalculating(true);
    let data: IEOD = {
      start: formatDateForDisplay(startDate),
      end: formatDateForDisplay(endDate),
      total: getTotal().toFixed(2),
      noOfOrders: receipts.length.toString(),
      card: "£" + totalCardPayment().toFixed(2),
      cash: "£" + totalCashPayment().toFixed(2),
      eatIn: eatInCount().toString(),
      takeOut: takeoutCount().toString(),
      collection: collectionCount().toString(),
      delivery: deliveryCount().toString(),
      printerSettings: context.Configuration.getSettings().printers,
      breakdown: ebd,
    };

    const receiptJson = JSON.stringify(data);
    var encodedStringBtoA = btoa(receiptJson);

    let url = "https://receipt.waepos.com/endOfday/data=" + encodedStringBtoA;

    window.location.href = url;
    setCalculating(false);
  }

  const modal = (): JSX.Element => {
    return (
      <>
        <Modal show={props.show} onHide={() => props.close()} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Report</Modal.Title>
          </Modal.Header>
          <Modal.Body>{content()}</Modal.Body>
          <Modal.Footer className="modal-footer">
            <Button
              variant="primary"
              style={{
                width: 100,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => printEOD()}
            >
              Print
            </Button>
            <Button
              variant="success"
              style={{
                width: 150,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => props.close()}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  return (
    <>
      <>{modal()}</>
    </>
  );
};
